import UserSystem from "components/Profiles/UserSystem";
import NotFooterLayout from "layouts/NotFooterLayout";

function UserSystemPage() {
  return (
    <>
      <NotFooterLayout namePage="ผู้ใช้งานระบบ">
        <div className="layout-content">
          <UserSystem />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default UserSystemPage;
